<ng-template wmTemplate>
  <ng-container>
    @if (!activitiesLoading) {
      <fa-icon class="action" [icon]="faSyncAlt" (click)="reloadActivities()"></fa-icon>
    }
    @if (activitiesLoading) {
      <fa-icon class="action" [icon]="faSyncAlt" animation="spin"></fa-icon>
    }
  </ng-container>
</ng-template>

<div class="view-content">
  <div class="activities-filter">
    <div class="filter-bar">
      <input type="text" pInputText placeholder="Filter activities" [(ngModel)]="filter" (ngModelChange)="filterChanged()"/>
      <div class="filter-icon" [ngClass]="{'filters-active': filtersActive}">
        <fa-icon (click)="toggleShowFilters()" [icon]="faFilter"></fa-icon>
      </div>
    </div>
    @if (showFilters) {
      <div class="filter-bar">
        <div class="filter">
          <p-multi-select [options]="this.auditInfo.availableTestObjects || []" [(ngModel)]="selectedTestObjects" defaultLabel="Test Object" (onChange)="filterChanged()">
            <ng-template pTemplate="selectedItems">
              @if (selectedTestObjects.length === 0) {
                <span>Test Object</span>
              }
              @if (selectedTestObjects.length !== 0) {
                <span>Test Objects: {{ getLabelForSelectedTestObjects() }}</span>
              }
            </ng-template>
          </p-multi-select>
        </div>
        <div class="filter">
          <p-multi-select [options]="this.auditInfo.availableTags || []" [(ngModel)]="selectedTags" defaultLabel="Tags" (onChange)="filterChanged()">
            <ng-template let-tag pTemplate="item">
              <wm-tags [onlyread]="true" [tags]="[tag.value]"></wm-tags>
            </ng-template>
            <ng-template pTemplate="selectedItems">
              @if (selectedTags.length === 0) {
                <span>Tags</span>
              }
              @if (selectedTags.length !== 0) {
                <span>Tags: {{ getLabelForSelectedTags() }}</span>
              }
            </ng-template>
          </p-multi-select>
        </div>
        <div class="filter">
          <p-multi-select [options]="this.auditInfo?.availableExecutionStatuses || []" [(ngModel)]="selectedExecutionStatuses" defaultLabel="Status" (onChange)="filterChanged()">
            <ng-template pTemplate="selectedItems">
              @if (selectedExecutionStatuses.length === 0) {
                <span>Status</span>
              }
              @if (selectedExecutionStatuses.length !== 0) {
                <span>Status: {{ selectedExecutionStatuses.join(', ') }}</span>
              }
            </ng-template>
          </p-multi-select>
        </div>
        <div class="filter">
          <p-multi-select [options]="this.auditInfo.availableEvaluationStatuses || []" [(ngModel)]="selectedEvaluationStatuses" defaultLabel="Result" (onChange)="filterChanged()">
            <ng-template pTemplate="selectedItems">
              @if (selectedEvaluationStatuses.length === 0) {
                <span>Result</span>
              }
              @if (selectedEvaluationStatuses.length !== 0) {
                <span>Result: {{ selectedEvaluationStatuses.join(', ') }}</span>
              }
            </ng-template>
          </p-multi-select>
        </div>
      </div>
    }
  </div>

  @if (!!filteredTasks) {
    <div class="activities">
      @for (task of filteredTasks!; track task) {
        <div class="task" (click)="openActivity(task.id)" [ngClass]="{'active': activeActivity === task.id}" [id]="'activity_' + task.id" [class.animate]="this.taskAnimationStates[task.id]" (animationend)="resetTaskBlinkingAnimation(task.id)">
          <div class="task-header">
            <div class="task-evaluation-status">
              @if (task.evaluationStatus === 'undecided') {
                <fa-icon class="undecided" [icon]="faQuestionCircle" size="2x" pTooltip="Undecided"></fa-icon>
              }
              @if (task.evaluationStatus === 'passed') {
                <fa-icon class="passed" [icon]="faThumbsUp" size="2x" pTooltip="Passed"></fa-icon>
              }
              @if (task.evaluationStatus === 'failed') {
                <fa-icon class="failed" [icon]="faThumbsDown" size="2x" pTooltip="Failed"></fa-icon>
              }
              @if (task.evaluationStatus === 'notapplicable') {
                <fa-icon class="not-applicable" [icon]="faBan" size="2x" pTooltip="Not applicable"></fa-icon>
              }
            </div>
            <div class="task-execution-status">
              @if (task.executionStatus === 'notstarted') {
                <fa-icon class="undecided" [icon]="faTasks" size="2x" pTooltip="Not started"></fa-icon>
              }
              @if (task.executionStatus === 'inprogress') {
                <fa-icon class="inprogress" [icon]="faRunning" size="2x" pTooltip="In progress"></fa-icon>
              }
              @if (task.executionStatus === 'waitingforreview') {
                <fa-icon class="waitingforreview" [icon]="faHourglass" size="2x" pTooltip="Waiting for review"></fa-icon>
              }
              @if (task.executionStatus === 'finished') {
                <fa-icon class="finished" [icon]="faFlagCheckered" size="2x" pTooltip="Finished"></fa-icon>
              }
              @if (task.executionStatus === 'skipped') {
                <fa-icon class="skipped" [icon]="faForward" size="2x" pTooltip="Skipped"></fa-icon>
              }
              @if (task.executionStatus === 'blocked') {
                <fa-icon class="blocked" [icon]="faHandPaper" size="2x" pTooltip="Blocked"></fa-icon>
              }
            </div>
            <div class="task-info">
              <div class="task-spec">{{ this.auditInfo.specs![task.assessedSpec]?.displayId }} {{ this.auditInfo.specs![task.assessedSpec]?.title }}</div>
              <div class="task-object">
                <fa-icon [icon]="faGlobe"></fa-icon>
                <span>{{ getTaskTargetName(task) }}</span>
                @if(canOpenTaskTarget(task)) {
                  <fa-icon class="task-object-action" pTooltip="Open in Browser" [icon]="faTv" (click)="openInBrowser(task)"></fa-icon>
                }
              </div>
            </div>
            <div class="finding-info">
              @if (!!task.numberOfFindings) {
                <div class="finding-count" pTooltip="# of findings" tooltipPosition="right">
                  {{task.numberOfFindings}}
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
